import { PageHeader } from "@/components/StatCard";
import { AiCallSettingsCard } from "@/components/AiCallSettingsCard";

export default function AdminAiScript() {
  return (
    <div data-testid="admin-ai-script-page">
      <PageHeader title="AI Call Script" subtitle="Ava's voice, opening line and phone instructions used on every Retell AI call." />
      <AiCallSettingsCard />
    </div>
  );
}
